export default __webpack_public_path__ + "static/harvey-a82ba1d28f2392c52218a058520ecea4.png";